import React from 'react';
const StaticContext = React.createContext();

const useStaticContext = () => {
  const context = React.useContext(StaticContext);
  if (context === undefined) {
    throw new Error('useStaticContext must be used within a StaticContext');
  }

  return context;
};

export {StaticContext, useStaticContext};
